export default __webpack_public_path__ + "components/wind-icon/static/WNW@2x-ff14d08b4a0d3c2142fe2f7ee0456c89.png";